import { z } from 'zod'

// Configure the browser interpreter before App or claim schemas are constructed.
// The normal JIT feature probe uses Function() and emits a CSP violation even
// when Zod catches the exception. Server validators keep their existing config.
z.config({ jitless: true })
